function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n   display: ", ";\n   position: absolute;\n   top: ", ";\n   ", " : 0;\n   list-style: none;\n   margin: 0;\n   padding: 0;\n   min-width: 180px;\n   background-color: ", ";\n   box-shadow: -1px 5px 5px 0 hsla(222, 34%, 7%, 0.07);\n   line-height: 2.5rem;\n   white-space: normal;\n\n   && ", " {\n      margin: 0;\n      min-width: 100%;\n      line-height: 2.5rem;\n   }\n\n   ", " {\n      min-width: 100%;\n      font-family: SharpSans, sans-serif;\n      color: ", ";\n      border: none;\n      text-transform: none;\n      line-height: 2.5rem;\n\n      :hover,\n      :focus {\n         background-color: ", ";\n      }\n\n      &::after {\n         top: 17px;\n         right: auto;\n      }\n   }\n\n   & & {\n      padding-left: 1em;\n   }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useContext, useRef, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { TopNavMenuItem } from './TopNavMenuItem';
import { TopNavMenuLink } from './TopNavMenuLink';
import { SiteHeaderContext } from './SiteHeaderContext'; // TODO: Look for a better way to handle the global dom event listener (try forwardRef)

var SubmenuContainer = function SubmenuContainer(_ref) {
  var Comp = _ref.pres,
      props = _objectWithoutProperties(_ref, ["pres"]);

  var _useContext = useContext(SiteHeaderContext),
      expandMenuAt = _useContext.expandMenuAt;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var wrapperRef = useRef();
  var clickHandled = useRef();
  useEffect(function () {
    var handleDomClick = function handleDomClick(_ref2) {
      var target = _ref2.target;

      if (!clickHandled.current && wrapperRef && !wrapperRef.current.contains(target) || target && target.nodeName === 'A') {
        setVisible(false);
      }

      clickHandled.current = false;
    };

    document.addEventListener('click', handleDomClick);
    return function () {
      return document.removeEventListener('click', handleDomClick);
    }; // eslint-disable-next-line
  }, []);

  var handleClick = function handleClick() {
    setVisible(!visible);
    clickHandled.current = true;
  };

  var handleBlur = function handleBlur(e) {
    if ((window.matchMedia("(min-width: ".concat(expandMenuAt, ")")).matches || !_toConsumableArray(document.querySelectorAll('[data-rcl-collapsible-menu]')).find(function (node) {
      return node.contains(e.target);
    })) && !e.currentTarget.contains(e.relatedTarget)) {
      setVisible(false);
    }
  };

  return /*#__PURE__*/React.createElement(Comp, _extends({}, props, {
    visible: visible,
    onClick: handleClick,
    onBlur: handleBlur,
    wrapperRef: wrapperRef
  }));
};

var SubmenuHoc = function SubmenuHoc(Comp, props) {
  return /*#__PURE__*/React.createElement(SubmenuContainer, _extends({
    pres: Comp
  }, props));
};

var SubmenuWrapper = styled.div(_templateObject());
var SubmenuMenu = styled.ul(_templateObject2(), function (_ref3) {
  var visible = _ref3.visible;
  return visible ? 'block' : 'none';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.sizes.siteHeaderHeight;
}, function (_ref5) {
  var horizontalAlign = _ref5.horizontalAlign;
  return horizontalAlign;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.brandColors.white;
}, TopNavMenuItem, TopNavMenuLink, function (_ref7) {
  var theme = _ref7.theme;
  return theme.brandColors.darkGray;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.brandColors.extraLightGray;
});

var SubmenuPresentation = function SubmenuPresentation(_ref9) {
  var title = _ref9.title,
      Comp = _ref9.component,
      horizontalAlign = _ref9.horizontalAlign,
      visible = _ref9.visible,
      onClick = _ref9.onClick,
      onBlur = _ref9.onBlur,
      children = _ref9.children,
      wrapperRef = _ref9.wrapperRef;
  return /*#__PURE__*/React.createElement(SubmenuWrapper, {
    onBlur: onBlur,
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(Comp, {
    hasSubmenu: true,
    submenuOpen: visible,
    as: "button",
    onClick: onClick
  }, title), /*#__PURE__*/React.createElement(SubmenuMenu, {
    visible: visible,
    horizontalAlign: horizontalAlign
  }, children));
};

SubmenuPresentation.defaultProps = {
  visible: false,
  component: TopNavMenuLink,
  title: '',
  horizontalAlign: 'left',
  onBlur: undefined
};

var TopNavSubmenu = function TopNavSubmenu(props) {
  return SubmenuHoc(SubmenuPresentation, props);
};

export { TopNavSubmenu, SubmenuMenu };